<!-- 获取账号下所有授权停车场的编码接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: {
              "data": {
                "communityList": [
                  {
                    "communityId": 1000001,
                    "communityName": "翰天科技成"
                  },
                  {
                    "communityId": 100003,
                    "communityName": "翰天科技成3"
                  }
                ]
              },
              "message": "业务成功",
              "resultCode": 0,
              "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求开放平台获取该账号下的所有授权小区信息",
                t_url: this.commonUrls.test+"getAuthCommunities",
                p_url: this.commonUrls.prod+"getAuthCommunities",
                precondition: "无",
                fitSystem: "门禁系统",
                pattern: "开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'communityList', info2: '是', info3: 'JSONArray', info4: '停车场列表，parkName：停车场名称,parkCode：停车场编码' }
                        ]
                },{
                    titleName: 'communityList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'communityId', info2: '是', info3: 'String', info4: '小区编号' },
                        { info1: 'communityName', info2: '是', info3: 'String', info4: '小区名称' },

                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/acms/community/getAuthCommunities.vue